import type { ActualProps } from "./index.tsx";

type HistoryAwards = ActualProps["awards"];
export type HistoryBestRecordTeam = {
  abbrev: string;
  lost: number;
  name: string;
  otl?: number;
  region: string;
  tid: number;
  tied?: number;
  won: number;
};

export const getHistoryMajorAwards = (awards: HistoryAwards) =>
  [
    { key: "mvp", award: awards.mvp },
    { key: "dpoy", award: awards.dpoy },
    { key: "smoy", award: awards.smoy },
    { key: "mip", award: awards.mip },
    { key: "roy", award: awards.roy },
  ] as const;

export const getHistoryBestRecordTeams = (awards: HistoryAwards): HistoryBestRecordTeam[] =>
  (
    ((awards as { bestRecordConfs?: (HistoryBestRecordTeam | null | undefined)[] })
      .bestRecordConfs ?? [])
  ).filter((team): team is HistoryBestRecordTeam => team !== undefined && team !== null);

export const countNestedAwardTeamPlayers = (team: { players: unknown[] }[] | undefined) =>
  team?.reduce((sum, row) => sum + row.players.filter(Boolean).length, 0) ?? 0;

export const getHistorySeasonArchiveCounts = ({
  awards,
  retiredPlayers,
}: Pick<ActualProps, "awards" | "retiredPlayers">) => ({
  allDefensive: countNestedAwardTeamPlayers(awards.allDefensive),
  allLeague: countNestedAwardTeamPlayers(awards.allLeague),
  allRookie: awards.allRookie.filter(Boolean).length,
  retired: retiredPlayers.length,
});

export const hasHistoryChampionStory = ({ awards, champ }: Pick<ActualProps, "awards" | "champ">) =>
  champ !== undefined &&
  champ !== null &&
  awards.finalsMvp !== undefined &&
  awards.finalsMvp !== null;
